import { ApplicationSettings } from "../types";

export const getDefaultApplicationSettings = (): ApplicationSettings => {
  return {
    name: "AgencyText",
    primaryButtonColor: "rgba(0, 0, 0, 0.12)",
    primaryButtonHoverColor: "rgba(0, 0, 0, 0.12)",
    primaryTableHeaderColor: "rgba(0, 0, 0, 0.12)",
  };
};
